import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  dialog: {
    borderRadius: '4px'
  },

  header: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },

  transactionBadge: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderRadius: '4px',
    fontSize: 12,
    fontWeight: 500
  },

  tableHeader: {
    fontSize: 11,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },

  tableCell: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    fontSize: 13
  },

  footer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`
  },

  button: {
    borderRadius: '4px',
    fontSize: 13,
    textTransform: 'none',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}))

export default useStyles



